import firestoreServices from './firestore.service';

const userNotificationsFirestoreServices = firestoreServices(
  'userNotifications'
);

export default {
  ...userNotificationsFirestoreServices,
  where: (fieldPath, opStr, value, onResult) => {
    userNotificationsFirestoreServices
      .collectionRef()
      .where(fieldPath, opStr, value)
      .get()
      .then(async queryResult => onResult(queryResult));
  }
};
